<script lang="ts" generics="ITEM">
    import type {Readable} from 'svelte/store';
    import type {Fond} from 'typings/portaro.be.types';
    import type {Table} from '@tanstack/svelte-table';
    import type {SearchManager} from 'src/features/search/search-manager/search-manager';
    import {exists} from 'shared/utils/custom-utils';
    import {setSearchContext} from 'src/features/search/kp-search-context/search-context';
    import {createSearchToolbarContext} from 'src/features/search/kp-search-toolbar/search-toolbar.context';
    import SearchToolbarFacets from './SearchToolbarFacets.svelte';
    import SearchToolbarSortings from './SearchToolbarSortings.svelte';
    import SearchToolbarSearchBar from './SearchToolbarSearchBar.svelte';
    import SearchToolbarFondSelector from './SearchToolbarFondSelector.svelte';
    import SearchToolbarGridColumnsVisibility from './SearchToolbarGridColumnsVisibility.svelte';

    export let fond: Fond | null = null;
    export let relatedFonds: Fond[] | null = null;
    export let table$: Readable<Table<ITEM>> | null = null;
    export let inFullscreenPage = false;
    export let injectedSearchManager: SearchManager<ITEM> | null = null;
    export let searchType: 'record-name' | 'query' = 'query';

    if (exists(injectedSearchManager)) {
        setSearchContext<ITEM>(injectedSearchManager);
    }

    createSearchToolbarContext();
</script>

<div class="kp-search-toolbar" class:fullscreen={inFullscreenPage}>
    {#if exists(fond)}
        <SearchToolbarFondSelector {fond} {relatedFonds} on:fond-change/>
    {/if}

    <SearchToolbarFacets/>
    <SearchToolbarSortings/>

    {#if table$}
        <SearchToolbarGridColumnsVisibility {table$}/>
    {/if}

    <SearchToolbarSearchBar {searchType}/>
</div>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "styles/portaro.themes.less";

    .kp-search-toolbar {
        display: flex;
        flex-wrap: wrap;
        font-size: @font-size-small;
        padding: 0 @spacing-xs;
        column-gap: @spacing-l;
        row-gap: @spacing-sm;

        &.fullscreen {
            padding: 0 @spacing-xl;
            margin-top: 18px;
        }
    }

    :global {
        .kp-search-toolbar {
            .uicon:not(.dropdown-angle-arrow) {
                font-size: @font-size-default;
            }
        }
    }
</style>